import styled from 'styled-components';
const ChipContainer = styled.div `
    div:first-child {
        margin-right: 0.25rem;
    }

    div:nth-child {
        margin-left: 0.25rem;
        margin-right: 0.25rem;
    }

    div:last-child {
        margin-left: 0.25rem;
    }
`;
export default ChipContainer;
//# sourceMappingURL=index.js.map